import React, { memo } from "react";
import { Trans } from "react-i18next";

import {
	StyledRow,
	StyledColumn,
} from "../../../../../../../components/common";

import Mark from "../../../Mark";
import Marker from "../../../Marker";

import PassengerPointDiff from "../index";
import { PassengerFeatureMemo } from "./PassengerFeature";

const PassengerRemovePoint: React.FC<PassengerRemovePoint.Props> = ({
	passengerName,
	removedItems,
}): JSX.Element => {
	if (!removedItems.length) return <></>;
	return (
		<StyledColumn>
			<StyledRow>
				<Trans
					i18nKey={`change_history.orders.fields.passenger.points`}
					context="remove"
					values={{ name: passengerName }}
					components={{ mark: <Mark /> }}
				/>
			</StyledRow>
			<StyledColumn p={"0 0 0 10px"}>
				{removedItems.map(({ point, feature }, i) => {
					if (!point || !feature) return <></>;
					if (!point.lat || !point.lng) return <></>;
					return (
						<>
							<StyledRow key={`${passengerName}-${i}-remove`}>
								<Marker />
								<Trans
									i18nKey={`change_history.orders.fields.passenger.point`}
									values={{
										lat: `${point?.lat}`,
										lng: `${point?.lng}`,
									}}
									components={{ mark: <Mark /> }}
								/>
							</StyledRow>
							<PassengerFeatureMemo
								key={`${passengerName}-${i}-feature-remove`}
								feature={feature}
							/>
						</>
					);
				})}
			</StyledColumn>
		</StyledColumn>
	);
};
declare namespace PassengerRemovePoint {
	interface Props {
		passengerName: string;
		removedItems: RemovedItems;
	}

	type RemovedItems = PassengerPointDiff.PointChange;
}

export const PassengerRemovePointMemo = memo(PassengerRemovePoint);
export default PassengerRemovePoint;
